import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=dce8871c&scoped=true&"
import script from "./Layout.script.js?vue&type=script&lang=js&"
export * from "./Layout.script.js?vue&type=script&lang=js&"
import style0 from "./Layout.scss?vue&type=style&index=0&id=dce8871c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce8871c",
  null
  
)

export default component.exports